import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { customSettings } from "utils/customConfig";
import PageTitle from "utils/PageTitle";
import * as yup from "yup";
import BasicInformation from "./BasicInformation";

const schema = yup.object({
  turn: yup.string().required("Type is required"),
  number: yup.string().required("Number is required"),
  date: yup.string().required("Date is required"),
  party: yup.string(),
  vehicleNumber: yup.string().required("Vehicle Number is required"),
  driverName: yup.string().required("Driver Name is required"),
  driverContactNumber: yup
    .string()
    .required("Driver Contact Number is required"),
  details: yup
    .array()
    .of(
      yup.object({
        product: yup.string(),
        weight: yup.string().required("Weight is required"),
        sortOrder: yup.string(),
        status: yup.boolean(),
      })
    )
    .required("Details are required"),
  status: yup.boolean(),
});

const AddWeighmentEntry = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { details: [{}] },
  });
  const { handleSubmit, reset, setValue } = methods;

  // console.log(costCenterId);
  const onSubmit = async (data) => {
    console.log(data);

    let myData = {
      ...data,
      id: location?.state?.id ?? 0, // Use nullish coalescing to handle undefined or null
    };

    console.log(myData);

    // try {
    //   if (location?.state) {
    //     setLoading(true);
    //     await VouchersAPI.post(myData);
    //     setLoading(false);
    //     toast.success("Voucher Updated Successfully", {
    //       position: customSettings.toastPosition,
    //       autoClose: customSettings.toastClose,
    //     });
    //   } else {
    //     setLoading(true);
    //     await VouchersAPI.post(myData);
    //     setLoading(false);
    //     toast.success("Voucher Created Successfully", {
    //       position: customSettings.toastPosition,
    //       autoClose: customSettings.toastClose,
    //     });
    //   }

    //   // ------- Get all object keys form data and set empty values to reset ------------
    //   const keys = Object.keys(data);
    //   for (const key of keys) {
    //     submittedValues[key] = "";
    //   }
    //   reset({ ...submittedValues });
    //   navigate(-1);
    // } catch (error) {
    //   toast.error("Something Went Wrong", {
    //     position: customSettings.toastPosition,
    //     autoClose: customSettings.toastClose,
    //   });
    //   console.log(error);
    // }
  };

  const formatDate = (dateStr) => {
    return dateStr ? dateStr.split("T")[0] : "";
  };

  return (
    <>
      {/* <div className="py-2">
        <BreadCrumb />
      </div> */}

      <PageTitle name=" Weighments | Weighment Entry" />

      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Card>
            <Card.Header className="border-bottom">
              <Row className="flex-between-center ">
                <Col md>
                  <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
                    {" "}
                    Weighments | Weighment Entry
                  </h5>
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    Ok
                  </Button>
                </Col>
              </Row>
            </Card.Header>

            <BasicInformation />
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddWeighmentEntry;
